import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestBoxComponent } from './requestBox.component';
import { RequestBoxRoutingModule } from './requestBox-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from "ng-select";
import { BsDatepickerModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BoxRetalStampsModule } from '../share/boxRetalStamps/boxRetalStamps.module';
import { Select2ApiModule } from '../share/select2Api/select2Api.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    RequestBoxRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    BoxRetalStampsModule,
    Select2ApiModule,
    ModalModule,
    TranslateModule,

  ],
  declarations: [RequestBoxComponent]
})
export class RequestBoxModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/requestBox/requestBox.module.ts